
export default {
  name: "CrmTimelineItem",
  props: {
    date: {
      type: [String, Date],
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    user: {
      type: String,
      default: "",
    },
  },
  computed: {
    dateText() {
      return this.date ? new Date(this.date).toLocaleString("pt-BR") : "";
    },
    dotClass() {
      return {
        "is-success": this.status === "success",
        "is-danger": this.status === "danger",
        "is-warning": this.status === "warning",
      };
    },
  },
};
